import script from "./StudioContent.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioContent.vue?vue&type=script&setup=true&lang=js"

import "./StudioContent.vue?vue&type=style&index=0&id=82f435d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f435d2"]])

export default __exports__